<template>
  <div class="index_page ">
    <Header></Header>
    <div class="index_btm" style="padding: 50px 0 110px;">
      <div class="contain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-breadcrumb separator="/" v-if="nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'AppResourceMy', query: {nav_id: nav.id} }">{{nav.name}}</el-breadcrumb-item>
                <router-link style="float: right;color: #1680ff;" :to="{ name: 'AppResourceAdd', query: {nav_id: nav.id}}">我要上传</router-link>
            </el-breadcrumb>
          </div>
          
        
        <div class="list_box">
          <ul v-if="List.length >0">
            <template v-for="(item, index) of List">
              <li :class="item.attachment?item.attachment.type:''">
                <el-row :gutter="20">
                  <el-col :span="16">
                    <div class="list_lf">
                    <router-link :to="{ name: 'AppResourceInfo', params: {id: item.id}}"><span class="tit">{{item.title}}</span></router-link>
                    <div class="cont">{{item.desc}}</div>
                    <div class="tip"><span class="date">{{item.created_at}}</span><i class="i">/</i><span class="author">作者：{{(item.user)?item.user.username:''}}</span></div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="my-button">
                      <router-link :to="{ name: 'AppResourceEdit', params: {id: item.id}}"><el-button class="write" size="mini">编辑</el-button></router-link>
                      <el-button class="down" size="mini" @click="dowload(item)">下载</el-button>
                      <el-button  @click="deleteData(item.id, index)" type="danger" size="mini">删除</el-button>
                    </div>
                  </el-col>

                </el-row>
                 
              </li>
            </template>
          </ul>
          <div style="text-align: center;">暂无数据</div>
          <el-pagination :page-size="size" @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </el-card>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/header'
import Footer from '@/components/footer' 

import { resMy, resDelete } from '@/api/'

export default {
  data() {
    return {
      List: [],
      total: 0,
      size: 20,
      count: 0,
      page: 1,
      nav: {
        id: '100',
        name: '我的资源'
      }
    }
  },
  components: {Header, Footer},
  computed: {},
  mounted() {},
  created() {
    this.getList()
  },

  methods: {
    getList() {
      resMy({page: this.page, user_id: this.$store.state.user.id}).then(res=>{
        this.List = res.data
        // this.teahcer = this.List[0]['user']
        this.total = res.total
        this.size = res.per_page
      })
    },
    handleCurrentChange(page){
      this.page = page
      this.getList()
    },
    deleteData(id, index) {
    	this.$confirm('此操作将永久删除资源, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const data = {
              id: id
            }
            resDelete(data).then(res => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.List.splice(index, 1)
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
    },
    dowload(item){
      if(!item.attachment) {
        this.$message({
          type: 'error',
          message: '下载失败，文件不存在'
        })
        return
      }
      window.open(item.attachment.file)
    }
  }
};

</script>
<style scoped>
  .list_box li .list_lf{}
.list_rt{
}
.list_box li .el-button--default{
  position: relative;
}
.down{margin-left: 10px}
.my-button{
  margin: 20px
}
</style>
